<template>
  <div class="program_list">
    <titleBar :title="title" :border="true" @callback="exit_event" :callback="true"></titleBar>
    <div class="list" v-for="(item, index) in data">
      <span class="fl">第{{index + 1}}课</span>
      <div class="fl">
        <p>{{item.title}}</p>
        <p>{{item.courseTime}}</p>
      </div>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/lesson_loading.vue";
import titleBar from "@/components/common/titleBar.vue";
let token = utils.getQueryString("token");
let sourceId = utils.getQueryString("sourceId");
let version = utils.getQueryString("version");
let source = utils.getQueryString("source");
export default {
  name: "",
  data() {
    return {
      title: "课程大纲",
      data: "",
      loadingLock: true,
      status: "loading"
    };
  },
  methods: {
    initData: async function() {
      const [resp] = await ajax.all([
        ajax.get("/parent/live/get-goods-info", {
          params: {
            token: token,
            sourceId: sourceId,
            productSource: 1,
            version: version,
            source: source
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        this.loadingLock = false;
        this.data = resp.data.data.customData.outline;
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    exit_event() {
      this.$router.go(-1);
    }
  },
  components: {
    lesson_loading,
    titleBar
  },
  created: async function() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.program_list {
  height: 100vh;
  background: #fff;
  padding-top: 1.08rem;
  .list {
    padding-top: 0.4rem;
    padding-left: 0.24rem;
    margin: 0 0.3rem;
    height: 1.56rem;
    border-bottom: 1px solid #eee;
    span {
      display: block;
      width: 1.13rem;
      height: 0.27rem;
      line-height: 0.27rem;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      color: #f5833c;
    }
    p {
      margin-bottom: 0.22rem;
      height: 0.27rem;
      line-height: 0.27rem;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      color: #56586a;
      &:last-child {
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #9796a4;
      }
    }
    .fl {
      float: left;
    }
  }
}
</style>